module.exports = __webpack_public_path__ + "img/icon_person.9fcfe2f9.jpg";